import React, { useEffect, useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import { Popper } from '@mui/material';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

import "./color-picker.scss"

const SettingsSelectColor = ({
  id,
  label,
  initialValue,
  defaultValue,
  onChange,
  recentlySelectedColors,
  currentlyUsedColors,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [color, setColor] = useState('');
  const [timer, setTimer] = useState(null);

  const colorInfo = color.toUpperCase();

  const handleOpen = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = newValue => {
    setColor(newValue);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        onChange(id, newValue);
      }, 1000),
    );
  };

  const handleSelectColor = color => {
    setColor(color);
    onChange(id, color, false);
  };

  useEffect(() => {
    setColor(initialValue ?? defaultValue);
  }, [initialValue]);

  return (
    <>
      <div onClick={handleOpen} className="visual-menu-settings-picker">
        <div className="visual-menu-settings-picker-color" id="current-color" style={{ backgroundColor: color }} />

        <div id="info" className="d-flex justify-content-around flex-column">
          <div className="visual-menu-settings-picker-label">{label}</div>

          <div className="visual-menu-settings-picker-value">{colorInfo}</div>
        </div>
      </div>

      <Popper className="PickColorPopper" open={!!anchorEl} anchorEl={anchorEl}>
        <ClickAwayListener onClickAway={handleClose}>
          <div className="PickColorPopper-wrapper">
            <HexAlphaColorPicker color={color} onChange={handleChange} />

            <div className="d-flex">
              <div id="current-color" style={{ backgroundColor: color }} />

              <HexColorInput
                className="paylixecommerce-input color-picker-input"
                color={colorInfo}
                onChange={handleChange}
                prefixed
                alpha
              />
            </div>

            {recentlySelectedColors.length ? (
              <div className="color-picker-select">
                <div>Recently selected</div>

                <div className="d-flex flex-wrap" style={{ width: 198 }} >
                  {recentlySelectedColors.slice(-7).map((value, idx) => (
                    <div key={idx} id="color-button" style={{ backgroundColor: value }} tabIndex={0} onClick={() => handleSelectColor(value)} />
                  ))}
                </div>
              </div>
            ) : null}

            {currentlyUsedColors?.length && (
              <div className="color-picker-select">
                <div>Currently used</div>

                <div className="d-flex flex-wrap" style={{ width: 198 }} >
                  {currentlyUsedColors?.map((value, idx) => (
                    <div
                      key={idx}
                      id="color-button"
                      style={{ backgroundColor: value }}
                      tabIndex={0}
                      onClick={() => handleSelectColor(value)}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default SettingsSelectColor;
